/* eslint-disable arrow-body-style */

export const deepEqual = (object: Record<string, any>, compare_object: Record<string, any>) => {
    return JSON.stringify(object) === JSON.stringify(compare_object);
};

export const deepClone = <T extends Record<string, any>>(s: T): T => {
    return JSON.parse(JSON.stringify(s));
};
